import { Box } from "@mui/material";
import { BasicSelect } from "../../ui/dropdown";
import { CollapsedBox } from "../../ui/collapsed-box";
import { TextFieldStr } from "../../ui/text-field";
import { usePlannerContext } from "../../../services/context/planner-context";
import { CheckboxPlanner } from "../../ui/checkbox-planner";
import { useUserContext } from "../../../services/context/user-context";

export const Highbay = ({ area, nodeId }) => {
  const { setNodes } = usePlannerContext();
  const { viewOnly } = useUserContext();
  const formValues = area.building;

  const handleValueChange = (value, name) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        mt: "16px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <TextFieldStr
          label={"Min. Area"}
          unit="m²"
          placeholder="mandatory"
          name="rangeMin"
          requier={true}
          value={formValues.rangeMin}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={true}
          disabled={viewOnly}
        />

        <TextFieldStr
          label={"Max. Area"}
          unit="m²"
          placeholder="optional"
          name="maxArea"
          value={formValues.rangeMax}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={true}
          disabled={viewOnly}
        />
      </Box>
      <CollapsedBox height={490 /* 645 */}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <TextFieldStr
            label={"min. Inner Clearance Height"}
            unit="m"
            placeholder="optional"
            name="height"
            value={formValues.height}
            setValue={handleValueChange}
            area={area}
            disabled={viewOnly}
          />

          <TextFieldStr
            label={"Min. Clear Span"}
            unit="m"
            placeholder="optional"
            name="minClearSpan"
            value={formValues.minClearSpan}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
            disabled={viewOnly}
          />

          <BasicSelect
            label={"No. of Docking Stations"}
            unit={""}
            name="numDocks"
            placeholder="optional"
            value={formValues.numDocks}
            setValue={handleValueChange}
            options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
            area={area}
          />

          <BasicSelect
            label={"Truck and Delivery Requirements"}
            unit={"t"}
            name="truckRequirement"
            placeholder="optional"
            value={formValues.truckRequirement}
            setValue={handleValueChange}
            options={[0, 3, 5, 7, 18, 40]}
            area={area}
            disabled={viewOnly}
          />

          <TextFieldStr
            label={"Cost per m²GFA"}
            unit="€/m²GFA"
            placeholder="optional"
            value={formValues.cost}
            name="cost"
            setValue={handleValueChange}
            area={area}
            disabled={viewOnly}
          />

          <TextFieldStr
            label={"No. of Employees"}
            unit=""
            placeholder="optional"
            name="numEmployees"
            value={formValues.numEmployees}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
            disabled={viewOnly}
          />

          <CheckboxPlanner
            label={"Isolated"}
            value={formValues.isolated}
            setValue={handleValueChange}
            name="isolated"
            area={area}
            disabled={viewOnly}
          />
        </Box>
      </CollapsedBox>
    </Box>
  );
};
